import { CSSProperties } from 'react'

import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  offerContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius / 4,
    padding: theme.spacing(3),
    boxShadow: theme.shadows[2],
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2)
    }
  } as SxProps,

  topInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius / 4,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1)
  } as SxProps,

  avatar: {
    marginRight: theme.spacing(2)
  } as SxProps,

  userContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  } as SxProps,

  userName: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.grey[800],
    textAlign: 'left'
  } as SxProps,

  userLocation: {
    textAlign: 'left'
  } as SxProps,

  getAmount: {
    marginLeft: 'auto',
    color: theme.palette.secondary.dark
  } as SxProps,

  itemDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2)
  } as SxProps,

  bottomInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },

  locationInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(1.6, 2),
    borderRadius: theme.shape.borderRadius / 6,
    paddingRight: theme.spacing(2),
    textAlign: 'left',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.6, 1)
    }
  } as SxProps,

  locationIcon: {
    display: 'flex',
    color: theme.palette.grey[400],
    fontSize: '1.2rem',
    marginRight: theme.spacing(1)
  } as SxProps,

  neededByContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(1.6, 2),
    borderRadius: theme.shape.borderRadius / 6,
    paddingRight: theme.spacing(2),
    flex: 1,
    alignSelf: 'stretch',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.6, 1)
    }
  },

  boldText: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.grey[600]
  } as CSSProperties,

  linkText: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    textDecoration: 'none'
  } as CSSProperties,

  lightText: {
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.grey[500]
  } as CSSProperties,

  modalBodySpacing: {
    marginTop: '20px'
  } as SxProps,

  modalUspsSection: {
    marginTop: theme.spacing(3)
  } as SxProps,

  modalUspsCheckboxSection: {
    marginTop: theme.spacing(2)
  } as SxProps,

  fulfillmentItemSection: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  } as SxProps,

  fulfillmentItemSectionInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'hidden',
    minWidth: 0
  } as SxProps,

  fulfillmentItemImageContainer: {
    width: '35px',
    height: '35px',
    minWidth: '35px',
    minHeight: '35px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  } as SxProps,

  fulfillmentItemImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  } as CSSProperties,

  fulfillmentItemDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    overflow: 'hidden'
  } as SxProps,

  fulfillmentItemTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    width: '100%',
    marginBottom: theme.spacing(0.5),
    minWidth: 0
  } as SxProps,

  fulfillmentItemTitle: {
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    flex: 1,
    minWidth: 0
  } as SxProps,

  specialHandlingIcon: {
    color: theme.palette.warning.main,
    fontSize: '1.25rem',
    flexShrink: 0,
    cursor: 'help'
  } as SxProps,

  fulfillmentItemMeta: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  } as SxProps,

  pickupInfoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(0.5),
    textAlign: 'left'
  } as SxProps,

  pickupInfoText: {
    textAlign: 'left'
  } as SxProps,

  pickupInfoIcon: {
    color: theme.palette.grey[400],
    fontSize: '1.2rem',
    marginRight: theme.spacing(1)
  } as SxProps,

  pickupInfoTooltipIcon: {
    color: theme.palette.grey[400],
    fontSize: '1rem',
    cursor: 'help',
    marginLeft: theme.spacing(0.5)
  } as SxProps
}

export default styles
